// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import siteMessage from "@insite/client-framework/SiteMessage";
import subscribe from "@insite/client-framework/Store/CommonHandlers/Subscribe";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField"; // Starter Custom Code
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as cssLinter from "css";
import parse from "html-react-parser";
import React, { Suspense, useContext, useMemo, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ArrowForward from "@store/Library/Components/Toolkit/Icons/ArrowForward";
import { widgetWrapperStyles } from "@store/Library/Components/Toolkit/WidgetWrapper";
import TextField, { TextFieldPresentationProps } from "@store/MobiusOverrides/TextField/TextField";
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import constants from "@toolkit/Framework/Common/GoogleAnalytics/constants";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import { ClickablePresentationProps, ClickableProps } from "@insite/mobius/Clickable/Clickable";
import getColor from "@insite/mobius/utilities/getColor";
import { IconPresentationProps } from "@store/MobiusOverrides/Icon/Icon";

import { FormFieldClickable } from "@store/MobiusOverrides/FormField/FormField";
import { buttonFieldIconClickableStyles, buttonFieldIconStyles } from "@store/Themes/common/mixins/button";
/* Store Custom Code - End */

type ButtonType = "text" | "icon";

/* Store Custom Code - Start */
const getInputProps = (
    icon: string | undefined,
    buttonType: ButtonType,
    label: string,
    alignment: string,
    baseProps: TextFieldPresentationProps,
): TextFieldPresentationProps => {
    const labelLength = label.length;
    const baseStylesClickableStyles = css`
        ${baseProps.iconClickableProps?.css}
        ${alignment === "left" ? `left: 0;` : `right: 0;`}
             border-radius: ${alignment === "left"
            ? `${pxToRem(4)} 0 0 ${pxToRem(4)}`
            : `0 ${pxToRem(4)} ${pxToRem(4)} 0`};
    `;
    const textPadding = pxToRem(labelLength * 8 + 36);
    if (buttonType === "text") {
        const padding = alignment === "left" ? `padding-left: ${textPadding};` : ``;
        const iconClickableProps = {
            css: css`
                &&& {
                    ${baseStylesClickableStyles}

                    width: fit-content !important;

                    > span {
                        position: relative;
                        clip-path: unset;
                        width: auto;
                        clip: unset;
                        height: auto;
                        color: white;
                    }
                }
            `,
        };
        return {
            ...baseProps,
            iconClickableProps,
            cssOverrides: {
                formField: css`
                    max-width: ${labelLength * 6 + 250}px;
                `,

                inputSelect: css`
                    ${padding}
                    :focus {
                        ${padding}
                    }
                `,
            },
        };
    }
    const iconProps = {
        src: icon || "Mail",
    };

    return {
        ...baseProps,
        iconProps,
        iconClickableProps: { css: baseStylesClickableStyles },
        cssOverrides: {
            formField: css`
                max-width: ${pxToRem(260)};
            `,
            inputSelect: css`
                ${alignment === "left" && `padding-left: ${pxToRem(54)}`};
                :focus {
                    ${alignment === "left" && `padding-left: ${pxToRem(54)}`};
                }
            `,
        },
    };
};
/* Store Custom Code - End */
const enum fields {
    label = "label",
    title = "title",
    description = "description",
    placeholder = "placeholder",
    disclaimer = "disclaimer",
    alignment = "alignment",
    customCSS = "customCSS",
    /* Store Custom Code - Start */
    icon = "icon",
    buttonType = "buttonType",
    /* Store Custom Code - End */
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.label]: string;
        [fields.description]: string;
        [fields.placeholder]: string;
        [fields.disclaimer]: string;
        [fields.alignment]: string;
        [fields.customCSS]: string;
        /* Store Custom Code - Start */
        [fields.icon]: string;
        [fields.buttonType]: ButtonType;
        /* Store Custom Code - End */
    };
}

const mapDispatchToProps = {
    subscribe,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface SubscribeStyles {
    mainGridContainer?: GridContainerProps; // Starter Custom Code
    titleGridItem?: GridItemProps;
    titleLabel?: TypographyPresentationProps;
    descriptionGridItem?: GridItemProps;
    descriptionText?: TypographyPresentationProps;
    emailGridItem?: GridItemProps;
    emailTextField?: TextFieldPresentationProps;
    emailButton?: ButtonPresentationProps;
    disclaimerGridItem?: GridItemProps;
    disclaimerText?: InjectableCss; // Starter Custom Code
    // Starter Custom Code
    wrapper?: InjectableCss;
}

export const subscribeStyles: SubscribeStyles = {
    titleLabel: {
        variant: "p", // Store Custom Code
        /* Store Custom Code - Start */
        css: css`
            margin-bottom: ${pxToRem(18)};
            font-weight: ${({ theme }) => theme.design.typography.weight.bold}; /* Store Custom Code */
        `,
        /* Store Custom Code - End */
    },
    descriptionText: {
        css: css`
            display: block;
            margin-bottom: ${pxToRem(18)}; /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    emailTextField: {
        /* Store Custom Code */
        mergeCss: true,
        // ...buttonGetFieldIconProps(Mail), // Store Custom Code
        sizeVariant: "default", // Store Custom Code
        /* Store Custom Code - Start */
        iconClickableProps: {
            css: css`
                background-color: ${getColor("primary")};
                color: ${getColor("primary.contrast")};
            `,
        },

        /* Store Custom Code - End */
    },
    disclaimerText: {
        css: css`
            margin-top: ${pxToRem(5)};
            font-size: ${x => x.theme.design.typography.size.tiny};
        `,
    },
    wrapper: {
        css: css`
            ${widgetWrapperStyles.css}
            margin-bottom: ${pxToRem(28)}; /* Store Custom Code */
        `,
    },
};

/* Starter Custom Code - Start */
const defaultCustomCss = `.title{
}

.description-text{
}

.email-text-field{
}

.email-button{
}

.disclaimer-text{
}`;
/* Starter Custom Code - End */

export const CmsSubscribe = ({ fields, subscribe, id }: Props) => {
    const emailRequiredFieldMessage = siteMessage("EmailSubscription_EmailIsRequiredErrorMessage");
    const emailFieldMessage = siteMessage("EmailSubscription_EmailIsInvalidErrorMessage");

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(emailRequiredFieldMessage);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const toasterContext = useContext(ToasterContext);

    const styles = useMergeStyles("subscribe", subscribeStyles);
    /* Store Custom Code - Start */
    const { icon: iconKey, buttonType } = fields;
    const textFieldProps = useMemo(
        () => getInputProps(iconKey, buttonType, fields.label, fields.alignment, styles.emailTextField),
        [iconKey, buttonType, fields.label, fields.alignment, styles.emailTextField],
    );
    /* Store Custom Code - End */
    /* Starter Custom Code - Start */
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [canTrackFormStart, setCanTrackFormStart] = useState(true);
    const trackFormStart = ga.use.trackFormStart({ form_name: constants.subscribeNewsletter.form_name });
    const trackFormSubmit = ga.use.trackFormSubmit({ form_name: constants.subscribeNewsletter.form_name });
    /* Starter Custom Code - End */

    const onSubscribeClick = () => {
        setIsSubmitted(true);
        if (!checkEmail(email)) {
            return;
        }

        subscribe({
            email,
            onSuccess: () => {
                toasterContext.addToast({ body: siteMessage("Email_Subscribe_Success"), messageType: "success" });
                /* Starter Custom Code - Start */
                trackFormSubmit();
                setCanTrackFormStart(true);
                setIsSubmitting(false);
                setEmail("");
                /* Starter Custom Code - End */
            },
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    this.onSuccess?.();
                }
            },
        });
    };

    const emailChangeHandler = (email: string) => {
        checkEmail(email);
        setEmail(email);

        /* Starter Custom Code - Start */
        if (canTrackFormStart) {
            trackFormStart();
            setCanTrackFormStart(false);
        }
        /* Starter Custom Code - End */
    };

    const checkEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : validateEmail(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    // Starter Removed - gridItemCss

    const customCssWrapper = {
        css: css`
            ${styles.wrapper?.css /* Starter Custom Code */}
            ${fields.customCSS}
        `,
    };

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSubscribeClick();
    };
    /* Store Custom Code - Start */
    return (
        <Suspense
            fallback={
                <></>
            } /* Needed because of a bug where the dynamic import isn't finishing in shell when changing icons */
        >
            <StyledWrapper {...customCssWrapper} as="form" onSubmit={onSubmit} noValidate>
                {fields.title ? (
                    <Typography className="title" {...styles.titleLabel}>
                        {fields.title}
                    </Typography>
                ) : null}
                {fields.description ? (
                    <Typography className="description-text" {...styles.descriptionText} forwardAs="label" htmlFor={id}>
                        {fields.description}
                    </Typography>
                ) : null}
                <TextField
                    className="email-text-field"
                    id={id}
                    placeholder={fields.placeholder}
                    value={email}
                    onChange={e => emailChangeHandler(e.currentTarget.value)}
                    error={isSubmitted && emailError}
                    labelId={id}
                    clickableText={fields.label}
                    {...textFieldProps}
                    readOnly={isSubmitting}
                    isLoading={isSubmitting}
                />
                {fields.disclaimer ? (
                    <StyledWrapper className="disclaimer-text" {...styles.disclaimerText}>
                        {parse(fields.disclaimer, parserOptions)}
                    </StyledWrapper>
                ) : null}
            </StyledWrapper>
        </Suspense>
    );
    /* Store Custom Code - End */
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule<Bunzl.BunzlDefinition> = {
    component: connect(null, mapDispatchToProps)(CmsSubscribe),
    definition: {
        group: "Basic",
        icon: "bell",
        fieldDefinitions: [
            // bunzl removed code
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "", // Starter Custom Code
                fieldType: "Translatable",
                tab: basicTab,
                sortOrder: 0,
            },
            /* Store Custom Code - Start */
            {
                name: fields.alignment,
                displayName: "Button Alignment",
                editorTemplate: "DropDownField",
                defaultValue: "left",
                fieldType: "General",
                options: [
                    { displayName: "Left", value: "left" },
                    { displayName: "Right", value: "right" },
                ],
                sortOrder: 2,
            },
            {
                name: fields.icon,
                displayName: "Icon",
                editorTemplate: "IconPickerField",
                defaultValue: "Mail",
                fieldType: "General",
                isVisible: item => item.fields.buttonType === "icon",
                sortOrder: 4,
            },
            {
                name: fields.buttonType,
                displayName: "Button Type",
                editorTemplate: "DropDownField",
                defaultValue: "text",
                options: [
                    { displayName: "Text Button", value: "text" },
                    { displayName: "Icon Button", value: "icon" },
                ],
                fieldType: "General",
                sortOrder: 3,
            },
            /* Store Custom Code - End */
            {
                name: fields.description,
                displayName: "Description",
                editorTemplate: "TextField", // Starter Custom Code
                defaultValue: "Keep up-to-date on product news and the latest offers.", // Starter Custom Code
                fieldType: "Translatable",
                tab: basicTab,
            },
            {
                name: fields.placeholder,
                displayName: "Placeholder Text",
                editorTemplate: "TextField",
                defaultValue: "Enter email address",
                fieldType: "Translatable",
                tab: basicTab,
            },
            {
                name: fields.disclaimer,
                displayName: "Disclaimer",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Translatable",
                tab: basicTab,
            },
            {
                name: fields.label,
                displayName: "Button Label",
                editorTemplate: "TextField",
                defaultValue: "Subscribe",
                fieldType: "Translatable",
                tab: basicTab,
                /* Store Custom Code */
                sortOrder: 1,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
